import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

export const couchbaseAuthTypes = {
    NoAuthentication: 0,
    UseCredentials: 1
};

@Metamodel.model({
    name: 'Couchbase',
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Couchbase_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.Couchbase_DisplayText)
    ]
})
export class CouchbaseLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServerName
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public port?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_CredString,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public credString?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthMech
    })
    public authMech?: number;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    public isLegacyConnector: boolean = true;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
